import { Box, Button, Typography } from "@mui/material";

interface Props {
  value: number;
  /** Turns the count into a button — the keyboard-reachable way into the offers of an own Anfrage. */
  onClick?: () => void;
  ariaLabel?: string;
}

export function ExchangeCountCell({ value, onClick, ariaLabel }: Props) {
  const fontWeight = value > 0 ? 700 : 400;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
      {onClick ? (
        <Button
          variant="text"
          size="small"
          aria-label={ariaLabel}
          sx={{ minWidth: 0, px: 1.5, fontWeight }}
          onClick={(event) => {
            event.stopPropagation();
            onClick();
          }}
        >
          {value}
        </Button>
      ) : (
        <Typography variant="body2" fontWeight={fontWeight}>
          {value}
        </Typography>
      )}
    </Box>
  );
}
